// src/components/Loader.js
import React from 'react';
import './Loader.css'; // Подключаем CSS стили для лоадера

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="drop"></div>
        <div className="drop"></div>
        <div className="drop"></div>
        <div className="drop"></div>
      </div>
    </div>
  );
};

export default Loader;
